import Removed from '@assets/images/attachments/removed.svg?react'
import type React from 'react'

import { AttachedFileWrapper } from '../AttachedFileWrapper'
import css from './DeletedFile.module.scss'

interface Props {
  selected: boolean
}

export const DeletedFile: React.FC<Props> = ({ selected }) => (
  <AttachedFileWrapper selected={selected}>
    <div className={css.container}>
      <div className={css.iconWrapper}>
        <Removed />
      </div>
      <span className={css.title}>Deleted file</span>
    </div>
  </AttachedFileWrapper>
)
